/* Nhập tồn đầu kỳ từ phiếu đếm Excel — trang Kiểm kê (18/09/2026). */
export const openingImportEn = {
  openingImport: {
    title: "Opening balance from a count sheet (Excel)",
    intro: "Upload the filled count sheet. Each row is matched to a product by code and sub-ref; rows are grouped into one draft opening document per warehouse. Submit and post the documents in the list below to put the stock into Kho & LOT.",
    warehouse: "Warehouse when the sheet leaves it blank", date: "Count date", reason: "Reason", reasonDefault: "Opening stock count from the count sheet",
    file: "Count sheet (.xlsx)", reading: "Reading the sheet…", checking: "Checking rows…", recheck: "Check the rows again",
    summary: "{{ok}} rows ready · {{skipped}} counted zero · {{errors}} with errors", sheet: "Sheet: {{name}}",
    create: "Create opening documents", creating: "Creating…",
    created: "Created {{docs}} (draft). Submit, then post each one in the list below.",
    fixFirst: "Fix the rows marked in red in the sheet, then upload it again.",
    columns: { row: "Row", code: "Code", subRef: "Sub-ref", product: "Product", warehouse: "Warehouse", location: "Location", counted: "Counted", lot: "Lot", status: "Status" },
    status: { ok: "Ready", skipped: "Counted 0", error: "Error" },
    issues: {
      missing_code: "No product code", missing_count: "Not counted yet", invalid_count: "Quantity is not a valid number",
      product_not_found: "No product with this code and sub-ref", product_ambiguous: "Several products share this code and sub-ref",
      product_unit_missing: "The product has no unit — set it on the product first", warehouse_not_found: "Unknown warehouse", duplicate: "Same product and location twice",
      ambiguous_count: "Written as text: unclear whether it means thousands or decimals — retype the cell as a number in Excel",
      count_not_whole: "This unit is counted piece by piece — the count must be a whole number",
      already_opened: "Already in opening document {{doc}} for this warehouse — cancel that document first to count it again",
      unknown_location: "Location is not in this warehouse's location list — pick a listed location or add it under Warehouse locations",
    },
    readError: "The file could not be read as a count sheet: it needs the columns Code (Mã) and Counted (Số đếm).",
    empty: "No row has a counted quantity above zero.",
    reused: "This upload already created documents with different settings. Choose the file again to start a new import.",
    chooseFile: "Choose file…", noFile: "No file chosen",
    done: "Done. To import another sheet, choose the file again.",
  },
};
export const openingImportVi = {
  openingImport: {
    title: "Nhập tồn đầu kỳ từ phiếu đếm (Excel)",
    intro: "Tải lên phiếu đếm đã điền. Mỗi dòng được khớp với sản phẩm theo mã và mã phụ; các dòng gom thành một phiếu tồn đầu kỳ (nháp) cho mỗi kho. Nộp rồi ghi sổ từng phiếu ở danh sách bên dưới thì tồn mới vào Kho & LOT.",
    warehouse: "Kho dùng khi phiếu để trống cột Kho", date: "Ngày đếm", reason: "Lý do", reasonDefault: "Kiểm kê đầu kỳ theo phiếu đếm",
    file: "Phiếu đếm (.xlsx)", reading: "Đang đọc phiếu đếm…", checking: "Đang kiểm các dòng…", recheck: "Kiểm lại các dòng",
    summary: "{{ok}} dòng sẵn sàng · {{skipped}} dòng đếm được 0 · {{errors}} dòng lỗi", sheet: "Trang: {{name}}",
    create: "Lập phiếu tồn đầu kỳ", creating: "Đang lập…",
    created: "Đã lập {{docs}} (nháp). Nộp rồi ghi sổ từng phiếu ở danh sách bên dưới.",
    fixFirst: "Sửa các dòng báo đỏ trong tệp Excel rồi tải lên lại.",
    columns: { row: "Dòng", code: "Mã", subRef: "Mã phụ", product: "Sản phẩm", warehouse: "Kho", location: "Vị trí", counted: "Số đếm", lot: "Lô", status: "Trạng thái" },
    status: { ok: "Sẵn sàng", skipped: "Đếm được 0", error: "Lỗi" },
    issues: {
      missing_code: "Thiếu mã sản phẩm", missing_count: "Chưa điền số đếm", invalid_count: "Số đếm không phải số hợp lệ",
      product_not_found: "Không có sản phẩm mang mã và mã phụ này", product_ambiguous: "Nhiều sản phẩm cùng mã và mã phụ này",
      product_unit_missing: "Sản phẩm chưa có đơn vị — điền đơn vị trên sản phẩm trước", warehouse_not_found: "Không có kho này", duplicate: "Trùng sản phẩm và vị trí với dòng trên",
      ambiguous_count: "Ô ghi dạng chữ, không rõ là hàng nghìn hay số lẻ — trong Excel gõ lại ô này dạng số",
      count_not_whole: "Đơn vị này đếm từng cái — số đếm phải là số nguyên",
      already_opened: "Đã có trong phiếu tồn đầu kỳ {{doc}} ở kho này — huỷ phiếu đó trước nếu muốn đếm lại",
      unknown_location: "Vị trí không có trong danh mục vị trí của kho này — chọn vị trí có trong danh mục hoặc khai thêm ở Vị trí kho",
    },
    readError: "Không đọc được tệp như một phiếu đếm: cần có cột Mã và cột Số đếm.",
    empty: "Không có dòng nào đếm được số lượng lớn hơn 0.",
    reused: "Lần tải này đã lập phiếu với nội dung khác. Chọn lại tệp để bắt đầu một lần nhập mới.",
    chooseFile: "Chọn tệp…", noFile: "Chưa chọn tệp",
    done: "Xong. Muốn nhập phiếu đếm khác, chọn lại tệp.",
  },
};
export const openingImportZh = {
  openingImport: {
    title: "从盘点表导入期初库存（Excel）",
    intro: "上传已填写的盘点表。每行依代码与子参考对应产品；各仓库各生成一张期初库存草稿。于下方列表提交并过账后，库存才进入“仓库与批次”。",
    warehouse: "盘点表未填仓库时使用", date: "盘点日期", reason: "原因", reasonDefault: "依盘点表的期初盘点",
    file: "盘点表（.xlsx）", reading: "正在读取盘点表…", checking: "正在检查各行…", recheck: "重新检查各行",
    summary: "{{ok}} 行就绪 · {{skipped}} 行盘点为 0 · {{errors}} 行有误", sheet: "工作表：{{name}}",
    create: "创建期初库存单", creating: "创建中…",
    created: "已创建 {{docs}}（草稿）。请于下方列表逐张提交并过账。",
    fixFirst: "请修正 Excel 中标红的行后重新上传。",
    columns: { row: "行", code: "代码", subRef: "子参考", product: "产品", warehouse: "仓库", location: "库位", counted: "盘点数", lot: "批次", status: "状态" },
    status: { ok: "就绪", skipped: "盘点为 0", error: "错误" },
    issues: {
      missing_code: "缺少产品代码", missing_count: "尚未填写盘点数", invalid_count: "盘点数不是有效数字",
      product_not_found: "找不到此代码与子参考的产品", product_ambiguous: "多个产品使用相同代码与子参考",
      product_unit_missing: "产品未设置单位——请先在产品上设置", warehouse_not_found: "找不到此仓库", duplicate: "与上方行的产品与库位重复",
      ambiguous_count: "以文本格式输入，无法判断是千位分隔符还是小数——请在 Excel 中以数字重新输入",
      count_not_whole: "此单位逐个计数——盘点数必须为整数",
      already_opened: "已在此仓库的期初库存单 {{doc}} 中——如需重新盘点，请先取消该单",
      unknown_location: "库位不在此仓库的库位清单中——请选择清单中的库位，或在“库位”中添加",
    },
    readError: "无法以盘点表格式读取此文件：需要“代码（Mã）”与“盘点数（Số đếm）”字段。",
    empty: "没有任何一行盘点数大于 0。",
    reused: "此次上传已以不同内容创建单据。请重新选择文件以开始新的导入。",
    chooseFile: "选择文件…", noFile: "尚未选择文件",
    done: "完成。如要导入其他盘点表，请重新选择文件。",
  },
};
